var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RoamTransactionListTemplate',{attrs:{"screenConfig":_vm.setScreenConfig,"isXSmall":_vm.isXSmall,"isLarge":_vm.isLarge,"formsConfig":_vm.formsConfig}})}
var staticRenderFns = []

export { render, staticRenderFns }